/* global axios */
import ApiClient from './ApiClient';

class KanbanListsAPI extends ApiClient {
  constructor() {
    super('kanban_lists', { accountScoped: true });
  }

  get(kanbanBoardId) {
    return axios.get(this.url, { params: { kanban_board_id: kanbanBoardId } });
  }

  reorder({ kanbanBoardId, positionsHash }) {
    return axios.patch(`${this.url}/reorder`, {
      kanban_board_id: kanbanBoardId,
      positions_hash: positionsHash,
    });
  }

  archiveCards(listId) {
    return axios.post(`${this.url}/${listId}/archive_cards`);
  }
}

export default new KanbanListsAPI();
